var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerifyFactor2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5176 9.6602L8.5664 11.5879L9.6445 9.6602H11.4434L9.6504 12.7598L11.5254 16H9.7207L8.5781 13.9609L7.4355 16H5.6309L7.5059 12.7598L5.7129 9.6602H7.5176ZM18.0293 14.6816V16H12.1934V14.875L14.9531 11.916C15.2305 11.6074 15.4492 11.3359 15.6094 11.1016C15.7695 10.8633 15.8848 10.6504 15.9551 10.4629C16.0293 10.2715 16.0664 10.0898 16.0664 9.918C16.0664 9.6602 16.0234 9.4395 15.9375 9.2559C15.8516 9.0684 15.7246 8.9238 15.5566 8.8223C15.3926 8.7207 15.1895 8.6699 14.9473 8.6699C14.6895 8.6699 14.4668 8.7324 14.2793 8.8574C14.0957 8.9824 13.9551 9.1563 13.8574 9.3789C13.7637 9.6016 13.7168 9.8535 13.7168 10.1348H12.0234C12.0234 9.627 12.1445 9.1621 12.3867 8.7402C12.6289 8.3145 12.9707 7.9766 13.4121 7.7266C13.8535 7.4727 14.377 7.3457 14.9824 7.3457C15.5801 7.3457 16.084 7.4434 16.4941 7.6387C16.9082 7.8301 17.2207 8.1074 17.4316 8.4707C17.6465 8.8301 17.7539 9.2598 17.7539 9.7598C17.7539 10.041 17.709 10.3164 17.6191 10.5859C17.5293 10.8516 17.4004 11.1172 17.2324 11.3828C17.0684 11.6445 16.8691 11.9102 16.6348 12.1797C16.4004 12.4492 16.1406 12.7285 15.8555 13.0176L14.373 14.6816H18.0293Z",
    fill: "#5A5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerifyFactor2X);
export default __webpack_public_path__ + "static/media/not_verify_factor2x.d4b238acff50c1a09becbf56756c5230.svg";
export { ForwardRef as ReactComponent };